// let lastScrollY = window.scrollY;
//  const stickyBar = document.getElementById("LuminaStickyBar");

//   window.addEventListener("scroll", () => {
//     if (window.scrollY > lastScrollY) {
//          stickyBar.style.bottom = "0"; // Show bar when scrolling down
//     } else {
//     stickyBar.style.bottom = "-100px"; // Hide when scrolling up
//       }
//     lastScrollY = window.scrollY;
//   });

// let lastScrollY = window.scrollY;
// const stickyBar = document.getElementById("LuminaStickyBar");

// window.addEventListener("scroll", () => {
//   // Check if the user has scrolled down past 100vh (the height of the viewport)
//   if (window.scrollY > window.innerHeight) {
//     // Show the sticky bar when scrolling down after 100vh
//     if (window.scrollY > lastScrollY) {
//       stickyBar.style.bottom = "0"; // Show bar
//     } else {
//       stickyBar.style.bottom = "-100px"; // Hide bar when scrolling up
//     }
//   } else {
//     // If not past 100vh, hide the sticky bar
//     stickyBar.style.bottom = "-100px";
//   }
//   lastScrollY = window.scrollY; // Update scroll position
// });


let lastScrollY = window.scrollY;
const stickyBar = document.getElementById("LuminaStickyBar");

window.addEventListener("scroll", () => {
  // 120vh threshold
  const triggerPoint = window.innerHeight * 1.2;

  if (window.scrollY > triggerPoint) {
    if (window.scrollY > lastScrollY) {
      stickyBar.style.bottom = "0"; // Show bar
    } else {
      stickyBar.style.bottom = "-100px"; // Hide bar when scrolling up
    }
  } else {
    stickyBar.style.bottom = "-100px"; // Always hidden before 120vh
  }

  lastScrollY = window.scrollY;
});